var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tabs__switchers"
  }, _vm._l((_vm.content), function(cont) {
    return _c('div', {
      staticClass: "tabs__switcher",
      class: {
        'selected': _vm.currentTab === cont.text.$path
      },
      on: {
        "click": function($event) {
          _vm.setCurrentTab(cont.text.$path)
        }
      }
    }, [_vm._v(" " + _vm._s(cont.text.title))])
  })), _vm._v(" "), _c('div', {
    staticClass: "tabs__contents"
  }, _vm._l((_vm.content), function(cont) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (cont.text.$path == _vm.currentTab),
        expression: "cont.text.$path ==currentTab"
      }],
      staticClass: "tabs__content",
      class: {
        'selected': _vm.currentTab === cont.text.$path
      }
    }, [(cont.text.text_left_col) ? _c('div', {
      staticClass: "cols cols_2"
    }, [_c('div', {
      staticClass: "col",
      domProps: {
        "innerHTML": _vm._s(cont.text.text_left_col)
      }
    }), _vm._v(" "), (cont.text.text_right_col) ? _c('div', {
      staticClass: "col",
      class: {
        'static': _vm.isIE()
      },
      domProps: {
        "innerHTML": _vm._s(cont.text.text_right_col)
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (cont.text.text_content) ? _c('div', {
      domProps: {
        "innerHTML": _vm._s(cont.text.text_content)
      }
    }) : _vm._e(), _vm._v(" "), (cont.text.$path === 'investors') ? _c('div', [_c('Investors', {
      attrs: {
        "content": cont
      }
    })], 1) : _vm._e(), _vm._v(" "), (cont.text.$path === 'whyelbruscapital') ? _c('div', {
      staticClass: "elbrus-benefits"
    }, [(cont.text.text_benefit_1) ? _c('div', {
      staticClass: "elbrus-benefits__item",
      domProps: {
        "innerHTML": _vm._s(cont.text.text_benefit_1)
      }
    }) : _vm._e(), _vm._v(" "), (cont.text.text_benefit_2) ? _c('div', {
      staticClass: "elbrus-benefits__item",
      domProps: {
        "innerHTML": _vm._s(cont.text.text_benefit_2)
      }
    }) : _vm._e(), _vm._v(" "), (cont.text.text_benefit_3) ? _c('div', {
      staticClass: "elbrus-benefits__item"
    }, [_c('div', {
      staticClass: "cols cols_2"
    }, [_c('div', {
      staticClass: "col",
      domProps: {
        "innerHTML": _vm._s(cont.text.text_benefit_3)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "col"
    }, [_c('div', {
      staticClass: "companies"
    }, _vm._l((_vm.projects.item), function(project, key) {
      return (key < 5) ? _c('div', {
        staticClass: "companies__item",
        style: (("animation-name: companyAnimation" + (key + 1) + "; animation-delay: " + ((key * 900)/1000) + "s"))
      }, [(project.text.item.logo_black) ? _c('img', {
        attrs: {
          "src": project.text.item.logo_black.$src,
          "alt": ""
        }
      }) : _vm._e()]) : _vm._e()
    }))])])]) : _vm._e(), _vm._v(" "), (cont.text.text_benefit_4) ? _c('div', {
      staticClass: "elbrus-benefits__item",
      domProps: {
        "innerHTML": _vm._s(cont.text.text_benefit_4)
      }
    }) : _vm._e()]) : _vm._e()])
  }))])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57002f85","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tabs.vue
// module id = 194
// module chunks = 0